// @ts-check

/**
 * @import { IAuctionDto, IVotePublishDto } from '@api';
 * @import { IVideoPublicDto } from '../channel/videos.dto';
 */

// KEEP IN SYNC WITH API
/**
 * @typedef {{
 * text: string;
 * replyTo?: string;
 * images: {
 *     filename: string;
 *     label: string;
 *     image: string;
 * }[];
 * videos: {
 *     filename: string;
 *     video: string;
 * }[];
 * }} ChatMessageSchema
 */

// KEEP IN SYNC WITH API
/** @enum {typeof ChatStatus[keyof typeof ChatStatus]} */
export const ChatStatus = /** @type {const} */({
	ENABLED: 'ENABLED',
	ENABLED_PARTICIPANT: 'ENABLED_PARTICIPANT',
	ENABLED_OPERATOR: 'ENABLED_OPERATOR',
	DISABLED: 'DISABLED',
});

// KEEP IN SYNC WITH API AND WEBRTC-ROUTER
/** @enum {typeof ChatMessageType[keyof typeof ChatMessageType]} */
export const ChatMessageType = /** @type {const} */({
	MESSAGE: 'message',
	VOTE_RESULT: 'voteResult',
	AUCTION_RESULT: 'auctionResult',
	POST_SHARE: 'postShare',
	HOST_DELETED: 'hostDeleted',
	DELETED: 'deleted',
	HIDDEN: 'hidden',
});

// KEEP IN SYNC WITH API
/** @enum {typeof ThirdPartyPlatform[keyof typeof ThirdPartyPlatform]} */
export const ThirdPartyPlatform = /** @type {const} */({
	TELEGRAM: 'TELEGRAM',
	TWITCH: 'TWITCH',
	INSTAGRAM: 'INSTAGRAM',
	FACEBOOK: 'FACEBOOK',
});

// KEEP IN SYNC WITH API
/**
 * @typedef {{
 * 	_id: string,
 * 	avatar?: string,
 * 	nickname: string,
 * 	hashtag: string,
 *  type: 'channel' | 'guest',
 * }} IClientDto
 */

// KEEP IN SYNC WITH API
/**
 * @typedef {{
 * 	name?: string,
 *  username?: string,
 *  hashtag?: string,
 *  type: 'thirdPartyAuthor',
 * }} IChatMessageThirdPartyAuthorDto
 */

// KEEP IN SYNC WITH API
/**
 * @typedef {{
 * 	_id: string,
 *  authorName: string,
 *  text: string,
 *  isDeleted: boolean,
 * }} IChatMessageReplyToDto
 */

// TODO : IPostDto for post
// KEEP IN SYNC WITH API
/**
 * @typedef {{
 * 	_id: string,
 *  type: ChatMessageType
 *  author: IClientDto | IChatMessageThirdPartyAuthorDto,
 *  fromGuest: boolean,
 *  text: string,
 *  replyTo?: IChatMessageReplyToDto,
 *  vote?: IVotePublishDto,
 *  post?: object,
 *  auction?: IAuctionDto,
 *  images?: {
 * 		filename: string,
 * 		image: string,
 * 		label?: string,
 * 	}[],
 *  videos?: {
 *  	filename: string,
 *  	video: IVideoPublicDto,
 *  }[],
 *  createdAt: string,
 *  updatedAt: string,
 *  fromThirdParty: boolean,
 *  thirdPartyPlatform?: ThirdPartyPlatform,
 *  reactions: {
 * 		count: number,
 *  	emoji: string,
 * 	}[],
 *  isContentChanged: boolean,
 * }} IChatMessageDto
 */
